import {
  profileItem,
  ProfileItemVariant,
} from '@repo/themes/styled-system/recipes';
import { ComponentProps } from 'react';

export interface ProfileItemProps
  extends Partial<ProfileItemVariant>,
    ComponentProps<'div'> {}

const ProfileItem = ({ children, ...allProps }: ProfileItemProps) => {
  const [profileProps, props] = profileItem.splitVariantProps(allProps);
  const classes = profileItem(profileProps);

  return (
    <div {...props} className={classes.root}>
      {children}
    </div>
  );
};

const ProfileInfo = ({ children }: { children: React.ReactNode }) => (
  <div className={profileItem().info}>{children}</div>
);

ProfileItem.displayName = 'ProfileItem.Root';
ProfileInfo.displayName = 'ProfileItem.Info';

export default {
  Root: ProfileItem,
  Info: ProfileInfo,
};
